import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoanLayoutRoutingModule } from "./loan-layout-routing.module";
import { LoanLayoutComponent } from "./loan-layout.component";
import { SharedModule } from "../shared/shared.module";
import { LoanDashboardModule } from "./components/loan-dashboard/loan-dashboard.module";
import { NbRedirectModule } from "./components/nb-redirect/nb-redirect.module";
import { EmiSummaryComponent } from "./components/loan-dashboard/components/re-payment/component/emi-summary/emi-summary.component";
import { RePaymentService } from "./components/loan-dashboard/components/re-payment/re-payment.service";
import { MatTooltipModule } from "@angular/material/tooltip";
import { KycNeededComponent } from "./components/loan-dashboard/components/aadhaar-kyc/components/kyc-needed/kyc-needed.component";
import { TimelineService } from "./components/loan-dashboard/components/timeline/timeline.service";
import { NetBankingService } from "./components/net-banking/net-banking.service";

@NgModule({
    declarations: [LoanLayoutComponent, EmiSummaryComponent, KycNeededComponent],
    imports: [
        CommonModule,
        SharedModule,
        LoanLayoutRoutingModule,
        MatTooltipModule,
        NbRedirectModule,
        LoanDashboardModule,
    ],
    providers: [RePaymentService, TimelineService, NetBankingService],
})
export class LoanLayoutModule {}
